var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.747,
    height: 22.114,
    viewBox: "0 0 17.747 22.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit-2",
    d: "M20.634,21.954H5.109a1.109,1.109,0,0,0,0,2.218H20.634a1.109,1.109,0,1,0,0-2.218ZM5.109,19.736h.1l4.624-.421a2.218,2.218,0,0,0,1.342-.632l9.98-9.98A2.129,2.129,0,0,0,21.077,5.7L18.039,2.659a2.218,2.218,0,0,0-2.95-.078l-9.98,9.98A2.218,2.218,0,0,0,4.477,13.9L4,18.527a1.106,1.106,0,0,0,1.109,1.209ZM16.5,4.211l3.027,3.027L17.307,9.4,14.335,6.429Zm-9.869,9.88,6.243-6.2,2.994,2.994L9.656,17.1l-3.327.31Z",
    transform: "translate(-3.996 -2.058)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.6ef835abb412e3916d3f296dff8531b1.svg";
export { ForwardRef as ReactComponent };